import script from "./StudentVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentVideo.vue?vue&type=script&setup=true&lang=js"

import "./StudentVideo.vue?vue&type=style&index=0&id=4dea11f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dea11f2"]])

export default __exports__